var CountryCodes = /* @__PURE__ */ ((CountryCodes2) => {
  CountryCodes2["AT"] = "AT";
  CountryCodes2["BE"] = "BE";
  CountryCodes2["DK"] = "DK";
  CountryCodes2["FI"] = "FI";
  CountryCodes2["FR"] = "FR";
  CountryCodes2["DE"] = "DE";
  CountryCodes2["IE"] = "IE";
  CountryCodes2["IT"] = "IT";
  CountryCodes2["NL"] = "NL";
  CountryCodes2["NO"] = "NO";
  CountryCodes2["PL"] = "PL";
  CountryCodes2["PT"] = "PT";
  CountryCodes2["ES"] = "ES";
  CountryCodes2["SE"] = "SE";
  CountryCodes2["CH"] = "CH";
  CountryCodes2["GB"] = "GB";
  return CountryCodes2;
})(CountryCodes || {});
var LanguageCodes = /* @__PURE__ */ ((LanguageCodes2) => {
  LanguageCodes2["DA"] = "DA";
  LanguageCodes2["FI"] = "FI";
  LanguageCodes2["FR"] = "FR";
  LanguageCodes2["DE"] = "DE";
  LanguageCodes2["EN"] = "EN";
  LanguageCodes2["IT"] = "IT";
  LanguageCodes2["NL"] = "NL";
  LanguageCodes2["NB"] = "NB";
  LanguageCodes2["PL"] = "PL";
  LanguageCodes2["PT"] = "PT";
  LanguageCodes2["ES"] = "ES";
  LanguageCodes2["SV"] = "SV";
  return LanguageCodes2;
})(LanguageCodes || {});
const COUNTRIES = {
  [
    "AT"
    /* AT */
  ]: "Austria",
  [
    "BE"
    /* BE */
  ]: "Belgium",
  [
    "DK"
    /* DK */
  ]: "Denmark",
  [
    "FI"
    /* FI */
  ]: "Finland",
  [
    "FR"
    /* FR */
  ]: "France",
  [
    "DE"
    /* DE */
  ]: "Germany",
  [
    "IE"
    /* IE */
  ]: "Ireland",
  [
    "IT"
    /* IT */
  ]: "Italy",
  [
    "NL"
    /* NL */
  ]: "Netherlands",
  [
    "NO"
    /* NO */
  ]: "Norway",
  [
    "PL"
    /* PL */
  ]: "Poland",
  [
    "PT"
    /* PT */
  ]: "Portugal",
  [
    "ES"
    /* ES */
  ]: "Spain",
  [
    "SE"
    /* SE */
  ]: "Sweden",
  [
    "CH"
    /* CH */
  ]: "Switzerland French",
  [
    "GB"
    /* GB */
  ]: "United Kingdom"
};
const LANGUAGES_BY_COUNTRIES = {
  [
    "AT"
    /* AT */
  ]: { [
    "DE"
    /* DE */
  ]: "Austria" },
  [
    "BE"
    /* BE */
  ]: {
    [
      "FR"
      /* FR */
    ]: "Belgium French",
    [
      "NL"
      /* NL */
    ]: "Belgium Dutch"
  },
  [
    "DK"
    /* DK */
  ]: { [
    "DA"
    /* DA */
  ]: "Denmark" },
  [
    "FI"
    /* FI */
  ]: { [
    "FI"
    /* FI */
  ]: "Finland" },
  [
    "FR"
    /* FR */
  ]: { [
    "FR"
    /* FR */
  ]: "France" },
  [
    "DE"
    /* DE */
  ]: { [
    "DE"
    /* DE */
  ]: "Germany" },
  [
    "IE"
    /* IE */
  ]: { [
    "EN"
    /* EN */
  ]: "Ireland" },
  [
    "IT"
    /* IT */
  ]: { [
    "IT"
    /* IT */
  ]: "Italy" },
  [
    "NL"
    /* NL */
  ]: { [
    "NL"
    /* NL */
  ]: "Netherlands" },
  [
    "NO"
    /* NO */
  ]: { [
    "NB"
    /* NB */
  ]: "Norway" },
  [
    "PL"
    /* PL */
  ]: { [
    "PL"
    /* PL */
  ]: "Poland" },
  [
    "PT"
    /* PT */
  ]: { [
    "PT"
    /* PT */
  ]: "Portugal" },
  [
    "ES"
    /* ES */
  ]: { [
    "ES"
    /* ES */
  ]: "Spain" },
  [
    "SE"
    /* SE */
  ]: { [
    "SV"
    /* SV */
  ]: "Sweden" },
  [
    "CH"
    /* CH */
  ]: {
    [
      "FR"
      /* FR */
    ]: "Switzerland French",
    [
      "DE"
      /* DE */
    ]: "Switzerland German",
    [
      "IT"
      /* IT */
    ]: "Switzerland Italian"
  },
  [
    "GB"
    /* GB */
  ]: { [
    "EN"
    /* EN */
  ]: "United Kingdom" }
};
var Versions = /* @__PURE__ */ ((Versions2) => {
  Versions2["ONE"] = "1";
  Versions2["TWO"] = "2";
  Versions2["THREE"] = "3";
  return Versions2;
})(Versions || {});
const defaultSovendusAppSettings = {
  voucherNetwork: {
    settingType: void 0,
    cookieTracking: true
  },
  optimize: {
    settingsType: void 0
  },
  checkoutProducts: true,
  version: "3",
  employeeBenefits: {
    isEnabled: false,
    showWidgetOnDashboard: false,
    addToSidebar: false
  }
};
const defaultIframeContainerId = "sovendus-container";
const sovendusPageApis = {
  // this only gets called when a optimize id is set
  // you don't have to whitelist this domain if you don't want to use Sovendus Optimize
  optimize: "https://www.sovopt.com/"
};
const defaultSovendusPageConfig = {
  settings: defaultSovendusAppSettings,
  country: void 0,
  integrationType: ""
};
const defaultSovendusThankyouPageConfig = {
  settings: defaultSovendusAppSettings,
  integrationType: "",
  sovDebugLevel: void 0,
  iframeContainerId: void 0,
  orderData: {},
  customerData: {}
};
const thankyouInterfaceData = {
  // keys that are used to look for values in cookies
  cookieData: {
    sovCouponCode: { cookieName: "sovCouponCode" },
    orderValue: { cookieName: "sovOrderValue" },
    orderCurrency: { cookieName: "sovOrderCurrency" },
    orderId: { cookieName: "sovOrderId" },
    sovReqToken: { cookieName: "sovReqToken" },
    puid: { cookieName: "puid" },
    sovDebugLevel: { cookieName: "sovDebugLevel", persistent: true }
  },
  // keys that are used to look for values in window[VariableIdentifiersType]
  windowVariableData: {
    trafficSourceNumber: {
      alias: ["trafficSourceNumber", "shopId", "shopNumber"]
    },
    couponCode: { alias: ["couponCode", "usedCouponCode"] },
    orderValue: { alias: ["orderValue"] },
    orderCurrency: { alias: ["orderCurrency"] },
    orderId: { alias: ["orderId"] },
    sessionId: { alias: ["sessionId"] },
    iframeContainerId: { alias: ["iframeContainerId"], storeAll: true }
  }
};
var VariableIdentifiersType = /* @__PURE__ */ ((VariableIdentifiersType2) => {
  VariableIdentifiersType2["integrationIdentifier_sovIframes"] = "sovIframes";
  VariableIdentifiersType2["legacy_integrationIdentifier_sovAbo"] = "_sovAboData";
  VariableIdentifiersType2["legacy_integrationIdentifier_gconData"] = "_gconData";
  return VariableIdentifiersType2;
})(VariableIdentifiersType || {});
const version1 = "v1";
const latestVersion = version1;
export {
  COUNTRIES,
  CountryCodes,
  LANGUAGES_BY_COUNTRIES,
  LanguageCodes,
  VariableIdentifiersType,
  Versions,
  defaultIframeContainerId,
  defaultSovendusAppSettings,
  defaultSovendusPageConfig,
  defaultSovendusThankyouPageConfig,
  latestVersion,
  sovendusPageApis,
  thankyouInterfaceData,
  version1
};
//# sourceMappingURL=index.mjs.map
